import React from 'react';
import styled from 'styled-components';
import ReactTooltip from 'react-tooltip';
import StyleConfig from 'src/constants/StyleConfig';

interface Props {
  type?: 'dark' | 'success' | 'warning' | 'error' | 'info' | 'light';
  place?: 'top' | 'right' | 'bottom' | 'left';
  effect?: 'float' | 'solid';
}

export const Tooltip = ({ ...props }: Props) => {
  const { type, place, effect } = props;
  return (
    <Styled>
      <ReactTooltip effect={effect} type={type} place={place} />
    </Styled>
  );
};

const Styled = styled.div`
  [data-id='tooltip'] {
    &.type-error {
      background-color: ${StyleConfig.COLOR.SECONDORY};
    }
  }
`;

Tooltip.defaultProps = {
  color: 'info',
  place: 'top',
  effect: 'float',
};

export default Tooltip;
